/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { NotificationType } from '@vaisala/rockhopper-components';

export enum AppNotification {
  NetworkLost = 'NetworkUnavailable',
  SessionInvalidated = 'SessionInvalidated',
  UploadRunning = 'UploadRunning',
  UploadFinished = 'UploadFinished',
  UploadError = 'UploadError',
  ReconstructionRunning = 'ReconstructionRunning',
  ReconstructionFinished = 'ReconstructionFinished',
  ReconstructionError = 'ReconstructionError',
}

export interface Notification {
  type?: NotificationType;
  content: string;
  closable?: boolean;
  linkText?: string;
  linkTo?: string;
  duration?: number;
}
